module.exports = __webpack_public_path__ + "static/media/info.be42499d.svg";